<script lang="ts" setup>
import ReactComponent from '@/components/React/ReactComponent.vue'

defineProps<{
  showUpgrade: boolean
}>()
</script>
<template>
  <ReactComponent
    class="d-flex"
    style="max-width: 32px"
    name="MobileMenu"
    :props="{ showUpgrade }"
  />
</template>
